"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloneITxBuildWithdrawal = exports.normalizeITxBuildWithdrawal = void 0;
var cardano_ledger_ts_1 = require("@harmoniclabs/cardano-ledger-ts");
var CanBeData_1 = require("../utils/CanBeData.js");
var obj_utils_1 = require("@harmoniclabs/obj-utils");
var plutus_data_1 = require("@harmoniclabs/plutus-data");
;
;
function normalizeITxBuildWithdrawal(_a) {
    var withdrawal = _a.withdrawal, script = _a.script;
    script = script === undefined ? undefined : (0, obj_utils_1.hasOwn)(script, "ref") ?
        {
            ref: script.ref.clone(),
            redeemer: (0, plutus_data_1.isData)(script.redeemer) ? (0, plutus_data_1.cloneData)(script.redeemer) : (0, CanBeData_1.forceData)(script.redeemer)
        } :
        {
            inline: script.inline.clone(),
            redeemer: (0, plutus_data_1.isData)(script.redeemer) ? (0, plutus_data_1.cloneData)(script.redeemer) : (0, CanBeData_1.forceData)(script.redeemer)
        };
    return {
        withdrawal: {
            rewardAccount: (0, cardano_ledger_ts_1.canBeHash28)(withdrawal.rewardAccount) ? new cardano_ledger_ts_1.Hash28(withdrawal.rewardAccount) : withdrawal.rewardAccount,
            amount: BigInt(withdrawal.amount)
        },
        script: script
    };
}
exports.normalizeITxBuildWithdrawal = normalizeITxBuildWithdrawal;
/** @deprecated use `normalizeITxBuildWithdrawal` instead */
function cloneITxBuildWithdrawal(stuff) {
    return normalizeITxBuildWithdrawal(stuff);
}
exports.cloneITxBuildWithdrawal = cloneITxBuildWithdrawal;
